"use strict";
// Todo move this file to date-time package
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndAvailabilityYear = exports.convertToDate = exports.parseTime = void 0;
const types_1 = require("./types");
const START_YEAR = 2000;
const END_YEAR = 2001;
/**
 * Converts a string representing a day and month to a Date object.
 * The expected format for the input string is 'day/month'.
 *
 * @param dayAndMonth - The string representing the day and month.
 * @param year - The year to use for the Date object (default: 2000).
 * @returns A Date object representing the converted day and month.
 */
function convertToDate(dayAndMonth, year = START_YEAR) {
    const [month, day] = dayAndMonth.split('/');
    if (!month || !day || isNaN(Number(month)) || isNaN(Number(day))) {
        throw new Error(`Invalid date format: ${dayAndMonth}`);
    }
    return new Date(`${year}-${month}-${day}`);
}
exports.convertToDate = convertToDate;
/**
 * Parses a time string into minutes.
 *
 * @param time - The time string to parse (in the format "HH:mm").
 * @returns The time in minutes.
 */
function parseTime(time) {
    const [hours, minutes] = time.split(':');
    if (isNaN(Number(hours)) || isNaN(Number(minutes)) || hours.trim() === '' || minutes.trim() === '') {
        throw new Error(`Invalid time format: ${time}`);
    }
    return Number(hours) * 60 + Number(minutes);
}
exports.parseTime = parseTime;
/**
 * Gets the year to use for the end availability date based on the start availability date.
 * when the end month is earlier than the start month, the end year is set to the next year.
 * @param activityTime - The activity time to get the year for.
 * @returns The year to use for the end availability date.
 */
function getEndAvailabilityYear(activityTime) {
    const [startMonth] = (activityTime.availabilityStartDate || types_1.DefaultDatesEnum.START_DATE).split('/');
    const [endMonth] = (activityTime.availabilityEndDate || types_1.DefaultDatesEnum.END_DATE).split('/');
    return Number(startMonth) > Number(endMonth) ? END_YEAR : START_YEAR;
}
exports.getEndAvailabilityYear = getEndAvailabilityYear;
//# sourceMappingURL=date-time.utils.js.map